import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
} from '@angular/core';
import {
  ApplicationState,
  getPasswordChangeSuccess,
  getSelectedMailbox,
  getShowCreateMailboxLink,
} from '../../../store/reducers';
import { Store } from '@ngrx/store';
import * as MailboxesActions from '../../store/actions/mailbox.actions';
import { Observable } from 'rxjs';
import { BrandService } from 'src/app/services/brand.service';

@Component({
  selector: 'mprd-manage-mailbox-container',
  templateUrl: 'manage-mailbox-container.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ManageMailboxContainerComponent implements OnInit {
  pendingStatus: boolean;
  selectedMailBox: any;
  showCreateMailboxLink$: Observable<boolean>;
  showMobileAppPromo: boolean;

  constructor(
    private store: Store<ApplicationState>,
    public changeDetectorRef: ChangeDetectorRef,
    private readonly brandService: BrandService,
  ) {}

  ngOnInit() {
    this.store.select(getSelectedMailbox).subscribe((selectedMailBox: any) => {
      if (selectedMailBox) {
        this.selectedMailBox = selectedMailBox;
        this.pendingStatus = selectedMailBox.status === 'pending';
        this.changeDetectorRef.markForCheck();
      }
    });

    this.store.select(getPasswordChangeSuccess).subscribe((state: any) => {
      if (
        state !== null &&
        state.code === 'change_password_success' &&
        this.pendingStatus
      ) {
        this.pendingStatus = false;
        this.store.dispatch(
          new MailboxesActions.ActivateAction(this.selectedMailBox),
        );
        this.changeDetectorRef.markForCheck();
      }
    });

    this.showCreateMailboxLink$ = this.store.select(getShowCreateMailboxLink);
    if (!this.brandService.isScarlet()) {
      this.showMobileAppPromo = true;
    }
  }
}
